import { createRoot } from "react-dom/client";
import "./styles/index.css";
import { App } from "./App";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container not found");
}

// StrictMode disabled in dev to avoid double renders that cause duplicate API calls
createRoot(container).render(<App />);
